import YachtLogo from '@assets/images/navigation_icons/yacht_logo.svg'
import { tvModeActive } from '@classes/app_url_params'
import YisToolTip from '@components/material/YisTooltip'
import { ROUTES } from '@constants/app_routes'
import { Button, Icon } from '@mui/material'
import type { CSSProperties } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'

const fontSize = '2rem'

const style: CSSProperties = {
  backgroundColor: 'transparent!important',
  height: '100%',
  width: '100%'
}

export default function ScreenLockerButton () {
  const tvMode = tvModeActive()
  const { t } = useTranslation()
  const url = tvMode ? ROUTES.HOME + '?tvmode=false' : ROUTES.HOME

  const btnStyle = tvMode ? { display: 'initial !important' } : undefined

  return <YisToolTip text="Screen Locker">
    <Button className={tvMode ? 'quit__tvmode__button' : 'home__button'} style={btnStyle}>
      <NavLink style={style} to={url}>
        <Icon className="wh-100">
          <img
            alt={t('Screen Locker')}
            style={{ fontSize }}
            src={YachtLogo}
            className="wh-100"
          />
        </Icon>
      </NavLink>
    </Button>
  </YisToolTip>
}
